module.exports = __webpack_public_path__ + "static/media/buy_start_service_make_3.16749765.jpg";